import { useState } from "react";
import { useDispatch } from "react-redux";
import { commonPostPutFormData } from "../redux/reducers/commonApiSlice";
import { upload_file } from "../data/ApiEndpoints";

/**
 * Custom hook for uploading files to Cloudfront
 * @returns {Object} - { uploadToCloudfront, isUploading, error }
 */
const useCloudFrontUpload = () => {
  const dispatch = useDispatch();
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Upload a file to Cloudfront
   * @param {File} file - The file to upload
   * @param {string} token - Authentication token
   * @returns {Promise<string|null>} - Returns the image URL if successful, null otherwise
   */
  const uploadToCloudfront = async (file, token) => {
    if (!file) return null;

    try {
      setIsUploading(true);
      setError(null);

      const formData = new FormData();
      formData.append("media", file);

      const result = await dispatch(
        commonPostPutFormData({
          method: "POST",
          endpoint: upload_file,
          token,
          requestBody: formData,
        })
      );

      if (result?.payload?.status === true) {
        return result?.payload?.img_url || null;
      } else {
        setError(result?.payload?.message || "Failed to upload file");
        return null;
      }
    } catch (err) {
      setError(err.message || "An error occurred during file upload");
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  return { uploadToCloudfront, isUploading, error };
};

export default useCloudFrontUpload;
